import { Control, Controller } from 'react-hook-form';
import { clsx } from 'clsx';
import { Switch } from 'src/components/ui/switch';
import { RadioGroup, RadioGroupItem } from 'src/components/ui/radio-group';
import { Input as CNInput } from 'src/components/ui/input';
import type { ProjectSettingsFormValues } from 'src/pages/ControlDeskPage/ProjectControls/ProjectSettingsModal/ProjectSettingFields';

type RateLimitKey = 'aiPerSession' | 'aiPerProject' | 'conversations';

export const RateLimitsField = ({
  control,
  label,
  toggleName,
  radioItemsName,
  limitName,
  radioItems,
  className = undefined,
  disabled = false,
}: {
  control: Control<ProjectSettingsFormValues>;
  label: string;
  toggleName: `${RateLimitKey}Toggle`;
  radioItemsName: `${RateLimitKey}Radio`;
  limitName: `${RateLimitKey}Limit`;
  // Periods; the radio value is the period label.
  radioItems: { id: number; label: string }[];
  className?: string;
  disabled?: boolean;
}) => {
  return (
    <div className={clsx('content', className)}>
      <div>
        <div className="flex gap-2.5">
          <Controller
            control={control}
            name={toggleName}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Switch
                checked={true}
                // onCheckedChange={onChange}
                disabled={true}
              />
            )}
          />
          <div className="flex flex-col gap-2.5">
            <label className="opacity-80 font-semibold text-sm text-ebony font-jamjuree">
              {label}
            </label>
            <div className="flex flex-col gap-2.5">
              <Controller
                control={control}
                name={radioItemsName}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <RadioGroup
                    disabled={disabled}
                    onChange={onChange}
                    onValueChange={onChange}
                    defaultValue={value}
                    className="flex space-x-3.5"
                  >
                    {radioItems.map((item) => (
                      <div key={item.id} className="flex items-center space-x-2.5 space-y-0">
                        <RadioGroupItem
                          value={item.label}
                          id={`${item.id}-${item.label}-${radioItemsName}`}
                        />
                        <label
                          htmlFor={`${item.id}-${item.label}-${radioItemsName}`}
                          className={clsx(!disabled && 'cursor-pointer')}
                        >
                          <p
                            className={clsx(
                              String(value) === String(item.id) ? 'opacity-100' : 'opacity-50',
                              !disabled && 'hover:opacity-100',
                              'font-medium text-sm text-ebony transition capitalize',
                            )}
                          >
                            {item.label}
                          </p>
                        </label>
                      </div>
                    ))}
                  </RadioGroup>
                )}
              />
              <div className="flex gap-1.5 items-center">
                <p className="font-medium text-sm text-ebony opacity-50">Limit</p>
                <Controller
                  control={control}
                  name={limitName}
                  render={({ field, fieldState: { error } }) => (
                    <CNInput
                      disabled={disabled}
                      placeholder="0"
                      type={'number'}
                      className="py-0.5 px-3.5 h-7 rounded-sm-5 w-fit"
                      {...field}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
